import { render, staticRenderFns } from "./TableReport.vue?vue&type=template&id=20c52446"
import script from "./TableReport.vue?vue&type=script&lang=ts"
export * from "./TableReport.vue?vue&type=script&lang=ts"
import style0 from "./TableReport.vue?vue&type=style&index=0&id=20c52446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports